import { set } from "lodash-es"
import { action, computed, makeAutoObservable, observable } from "mobx"

import { reasonGroupType, solutionList } from "@/api/app/types/setting"

import { langInfo } from "../Language"

export default class SettingStore {
  @observable public solutionListApi: solutionList[] = []
  @observable public addReasonGroup: reasonGroupType = {
    applicable_product_types: "",
    name: "",
    reason_ids: "",
  }
  @observable public activeLang: string = ""
  @observable public langList: langInfo[] = []
  // return setting  模块 integration 集成的tabs选项
  @observable public integrationTabIndex: number = 0

  constructor() {
    // 使用这个才会在 MobX 6 上才会更新视图
    makeAutoObservable(this)
  }

  @computed get completedActiveLang() {
    const select_item: any = this.langList.find(
      (langInfo) => langInfo.code === this.activeLang,
    ) as { name: string }

    if (select_item) return select_item.ename
    return ""
  }

  @action.bound
  setActiveLang(activeLang: string) {
    this.activeLang = activeLang
  }

  @action.bound
  setLangList(LangList: langInfo[]) {
    const findActiveLang = LangList.find(
      (langInfo) => langInfo.is_default === 1,
    ) as { code: string; name: string }

    if (this.activeLang === "") {
      this.activeLang = findActiveLang.code
    }
    this.langList = LangList
  }

  @action.bound
  setSolutionListApi(listApi: solutionList[]) {
    this.solutionListApi = listApi
  }

  @action.bound
  setAddReasonGroup(reasonTypes: reasonGroupType) {
    this.addReasonGroup = reasonTypes
  }

  @action.bound
  setFieldValue<T>(path: string, v: T) {
    set(this.solutionListApi, path, v)
  }

  @action.bound
  setIntegrationTabIndex(num: number) {
    this.integrationTabIndex = num
  }
}
